import { ThemeOptions } from "@mui/material";

const shape: ThemeOptions["shape"] = { borderRadius: 25 };

export default shape;
